<!-- 预约网点选择弹窗 -->
<template>
  <div class="site-select">
    <vanPopup
      v-model="showPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head">
          <div class="popup-title os-font-16-500">{{ title }}</div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <div class="site-list">
            <ul v-if="appointmentSiteList.length > 0">
              <li
                :class="{ active: activeIndex === index }"
                v-for="(site, index) in appointmentSiteList"
                :key="index"
                @click="selectSite(site, index)"
              >
                <div v-if="site.siteName" class="site-title" :class="{ nearest: site.nearest }">
                  <span class="os-font-10-400">{{ index + 1 }}</span>
                  <p class="os-font-14-400">{{ site.siteName }}</p>
                </div>
                <div class="site-info os-font-12-400">
                  <p v-if="site.address" class="site-address" @click="goToMap(site, index)">
                    <span class="address">{{ site.address }}</span>
                    <span v-if="site.distance" class="site-distance">{{ site.distance }}km</span>
                  </p>
                  <p v-if="site.businessTime && site.restTime" class="site-workTime">
                    <span>{{ site.businessTime }} （休息日：{{ site.restTime }}）</span>
                  </p>
                  <p v-if="site.delayWorkDay && site.delayWorkTime" class="site-delayedTime">
                    <span>延时服务：{{ site.delayWorkDay }}延时服务到{{ site.delayWorkTime }}</span>
                  </p>
                  <p
                    v-if="site.newPhone && splitPhone(site.newPhone).length === 1"
                    class="site-phone"
                  >
                    <a :href="`tel:${site.newPhone}`"
                      ><span>{{ site.newPhone }}</span></a
                    >
                  </p>
                  <p
                    v-else-if="site.newPhone && splitPhone(site.newPhone).length > 1"
                    class="site-phone"
                    @click="selectPhone(splitPhone(site.newPhone))"
                  >
                    <span>{{ site.newPhone }}</span>
                  </p>
                  <p v-if="site.hasRest && site.restDescription" class="site-remark">
                    <span
                      >临时公告：{{
                        site.restDescription ||
                        '临时公告：2022年06月14日～2022年06月17日用政府防疫要求，暂停营业'
                      }}</span
                    >
                  </p>
                </div>
              </li>
            </ul>
            <p class="os-font-12-400">没有更多啦～</p>
          </div>
          <div
            :class="{ 'confirm-button-disabled': activeIndex === -1 }"
            class="confirm-button os-font-16-500"
            @click="selectConfirm"
          >
            <p>确定</p>
          </div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import API from '@/api/index.js'
// import coordtransform from 'coordtransform'
export default {
  name: 'siteSelect',
  props: {
    title: {
      type: String,
      default: '选择预约网点'
    }
  },
  data() {
    return {
      showPopup: false,
      activeIndex: -1,
      selectedSite: {}
    }
  },
  watch: {
    appointmentSiteList(val) {
      if (val && val.length > 0) {
        this.autoSelect()
      }
    }
  },
  mounted() {},
  computed: {
    ...mapState('repair', ['appointmentSiteList', 'isWeChatApp'])
  },
  methods: {
    ...mapMutations('repair', ['SET_SELECTED_SITE']),
    ...mapActions('repair', ['getTimeList', 'jumpToH5']),
    async goToMap(site, index) {
      if (this.activeIndex !== index) {
        this.SET_SELECTED_SITE(site, index)
        return
      }
      if (this.isWeChatApp) {
        // 所有需要使用JS-SDK的页面必须先注入配置信息，否则将无法调用
        let res = await API.getWxSignature()
        if (res.retCode == 200 && res.data) {
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表
          })
          window.wx.ready(() => {
            // let tencentCoords = coordtransform.wgs84togcj02(site.longitude, site.latitude)
            window.wx.openLocation({
              longitude: site.longitude,
              latitude: site.latitude,
              name: site.siteName,
              address: site.address,
              scale: 15
            })
          })
          window.wx.error(() => {
            console.log('error')
          })
        }
      } else {
        this.jumpToH5(
          `https://uri.amap.com/marker?position=${site.longitude},${site.latitude}&name=${encodeURIComponent(site.siteName)}&coordinate=gaode&callnative=0`
        )
      }
    },
    selectSite(site, index) {
      this.selectedSite = site
      this.activeIndex = index
    },
    selectPhone(phoneList) {
      if (phoneList.length == 1) {
        window.open('tel:' + phoneList[0])
      } else {
        this.$emit('selectPhone', phoneList)
      }
    },
    // 自动选中第一个网点
    async autoSelect() {
      if (this.appointmentSiteList && this.appointmentSiteList[0]) {
        this.selectSite(this.appointmentSiteList[0], 0)
        this.SET_SELECTED_SITE(this.selectedSite)
        await this.getTimeList()
      }
    },
    // 阻止页面滚动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    // 电话份分离
    splitPhone(phone) {
      if (phone) {
        return phone.split('/')
      } else {
        return ''
      }
    },
    openPopup() {
      this.preventPageScroll()
      this.showPopup = true
    },
    closePopup() {
      this.restorePageScroll()
      this.showPopup = false
    },
    // 确认选择
    async selectConfirm() {
      if (this.activeIndex === -1) {
        return
      }
      this.SET_SELECTED_SITE(this.selectedSite)
      await this.getTimeList()
      this.restorePageScroll()
      this.showPopup = false
    }
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
